<!-- 
Contents of the CONTACTS tab of the levy collection provider page.
-->
<template>
  <div>
    <our-heading 
      :breadcrumbs="breadcrumbs"
      :title="title" 
      :subtitle="subtitle" 
      user-guide-topic="levy-collection-providers"
      user-guide-section="contacts"
    >
      <template v-slot:additional-nav>
        <div class="hidden-md-and-down" style="position:relative;top:-4px;">
          <v-btn 
            :to="`/providers/${providerId}`" flat small color="primary" 
            class="mt-0 mb-0 mr-0"
          >
            <v-icon class="mr-2">school</v-icon>
            Go to provider
          </v-btn>
          <our-next-previous-navigator
            :nav-url="`/levy-collections/${levyCollectionId}/providers/:id/contacts`"
            :next-page-action="nextPageAction"
            :previous-page-action="previousPageAction"
            id-field="providerId"
            module="levyCollectionProviders"
            class="mb-0"
          />
        </div>
      </template>
      <template v-slot:prefix>
        <favourite-indicator :provider="provider" />
      </template>
      <template v-slot:navigator>
        <levy-collection-navigator :levy-collection-id="levyCollectionId" />
      </template>
    </our-heading>
    <tabs :levy-collection-id="levyCollectionId" :provider-id="providerId">
      <provider-contact-listing :provider-id="providerId" :levy-collection-type="levyCollection.type" embedded />
    </tabs>
  </div>
</template>

<script>
import FavouriteIndicator from "@/components/levy-collection-providers/FavouriteIndicator.vue";
import LevyCollectionNavigator from "@/components/levy-collections/LevyCollectionNavigator.vue";
import Tabs from "./Tabs.vue";
import ProviderContactListing from "@/components/provider-contacts/ProviderContactListing.vue";
import IncompleteContactsExplanation from "@/components/levy-collection-providers/IncompleteContactsExplanation.vue";
import levyCollectionProviderMixins from "./mixins";

export default {
  name: "LevyCollectionProviderContacts",
  components: {
    FavouriteIndicator,
    LevyCollectionNavigator,
    Tabs,
    ProviderContactListing,
    IncompleteContactsExplanation
  },
  mixins: [levyCollectionProviderMixins]
};
</script>
